import { registerPlugin } from '@capacitor/core'

export interface PasskeyPlugin {
  startAuthentication: (_options: {
    options?: string
    rpId?: string
    challenge?: string
  }) => Promise<{ response: unknown }>
  startRegistration: (_options: {
    options?: string
    rpId?: string
    challenge?: string
    userName?: string
    userId?: string
  }) => Promise<{ response: unknown }>
  addListener: (_eventName: string, _listenerFunc: (_data?: unknown) => void) => void
}

export const Passkey = registerPlugin<PasskeyPlugin>('Passkey')
